module.exports = {"id":"199594","name":"Paco Montañés","rating":"72","photo":"./data/images/photos/1/199594.png","club":{"name":"CD Tenerife","logo":"./data/images/clubs/CDTenerife.png"},"positions":["MG","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PacoMontanes0.json
// module id = 3354
// module chunks = 0